import {
  allAttemptsInVoucher,
  voucherIsFinished,
  voucherIsInProgress,
  voucherIsInReview,
} from '@/helpers/vouchers'
import { hasPassedAttempt } from '@/helpers/certifications'
import { format } from 'date-fns'

export const vHelpers = {
  activeVouchers: voucher => voucher?.user_status?.active_vouchers ?? [],

  inactiveVouchers: voucher => voucher?.user_status?.inactive_vouchers ?? [],

  allVouchers: voucher => [
    ...vHelpers.activeVouchers(voucher),
    ...vHelpers.inactiveVouchers(voucher),
  ],

  activeAttempts: voucher =>
    vHelpers
      .activeVouchers(voucher)
      .reduce((acc, v) => [...acc, ...v.active_attempts], []),

  allAttempts: voucher => allAttemptsInVoucher(vHelpers.allVouchers(voucher)),

  allActiveVouchersAttempts: voucher =>
    allAttemptsInVoucher(vHelpers.activeVouchers(voucher)),

  passingAttempt: voucher =>
    vHelpers.allAttempts(voucher).find(attempt => hasPassedAttempt(attempt)),

  hasPassed: voucher => !!vHelpers.passingAttempt(voucher),

  isInProgress: voucher =>
    voucherIsInProgress(vHelpers.allActiveVouchersAttempts(voucher)),

  isFinished: voucher =>
    voucherIsFinished(vHelpers.allActiveVouchersAttempts(voucher)),

  isInReview: voucher => voucherIsInReview(vHelpers.allAttempts(voucher)),

  isStartStatus: voucher => {
    return (
      vHelpers.activeVouchers(voucher).length &&
      !vHelpers.activeAttempts(voucher).length &&
      !vHelpers.isFinished(voucher)
    )
  },

  retriesAvailable: voucher =>
    vHelpers
      .activeVouchers(voucher)
      .reduce((acc, v) => acc + v.remaining_attempts, 0),

  isRetakeAvailable: voucher => {
    return (
      !vHelpers.hasPassed(voucher) &&
      !vHelpers.isInProgress(voucher) &&
      !vHelpers.isInReview(voucher) &&
      vHelpers.allActiveVouchersAttempts(voucher).length > 0 &&
      vHelpers.retriesAvailable(voucher) > 0
    )
  },
  isVoucherAvailable: voucher => {
    const isInProgress = vHelpers.isInProgress(voucher)
    const isRetakeAvailable = vHelpers.isRetakeAvailable(voucher)
    const isStartStatus = vHelpers.isStartStatus(voucher)
    return isInProgress || isRetakeAvailable || isStartStatus
  },

  extensions: voucher => {
    const activeVouchers = vHelpers.activeVouchers(voucher)
    return activeVouchers.length ? activeVouchers[0].extensions : []
  },

  formatDate: date => format(new Date(date), 'LLLL d, yyyy'),

  isExternal: voucher => voucher.is_external,
}
